import type { ReactNode } from 'react';
import { AlignLeft, Calendar, CheckSquare, List, Mail, Paperclip, Phone, Type } from 'lucide-react';
import type { FieldType } from '../constants';

/** Alan tipi → palet/liste ikonu. Palette, FieldList ve önizlemede paylaşılır. */
export const FIELD_ICONS: Record<FieldType, ReactNode> = {
  text: <Type size={15} />,
  textarea: <AlignLeft size={15} />,
  email: <Mail size={15} />,
  phone: <Phone size={15} />,
  select: <List size={15} />,
  checkbox: <CheckSquare size={15} />,
  date: <Calendar size={15} />,
  file: <Paperclip size={15} />,
};

/** Metin uzunluğu (maxLength) anlamlı olan tipler. */
export function supportsMaxLength(type: FieldType): boolean {
  return type === 'text' || type === 'textarea' || type === 'email' || type === 'phone';
}
